import { toast } from "react-toastify";
import {
  fetchUpdateLocationSuccess,
  fetchUpdateLocationFailure,
} from "./reducer";
import { UPDATE_LOCATION } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const updateLocation =
  (jsonObj, locationId, setLoading, onSuccess) =>
  async (dispatch) => {
    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        UPDATE_LOCATION(locationId),
        "PUT",
        jsonObj
      );

      if (response?.error) {
        dispatch(fetchUpdateLocationFailure(response.error.message));
        toast.error(response.error.message);
      } else {
        dispatch(fetchUpdateLocationSuccess(response));
        dispatch(setSuccessMessage(true));
        onSuccess && onSuccess();
      }
    } catch (error) {
      dispatch(fetchUpdateLocationFailure("Something went wrong"));
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };